import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { toast } from "react-toastify";
import Breadcrumbs from "../../../components/Layout/Breadcrumb";
import DataTable from "../../../components/Common/DataTable";
import FormModal from "./Form";
import DeleteModal from "../../../components/Common/DeleteModal";

import { getDataTableQuery } from "../../../helpers/functions_helper";
import companyProfileTypeService from "../../../services/master.company.profile.service";
import { useTranslation } from "react-i18next";

const MasterForm = (props: any) => {
  const {t} = useTranslation();
  const masterName = t("Company profile");
  const breadcrumbItems = [
    {
      url: "/dashboard",
      label: t("Dashboard"),
      active: false,
    },
    {
      url: "#",
      label: masterName,
      active: true,
    },
  ];
  
  document.title = `${masterName} | ` + process.env.REACT_APP_NAME;

  const toastId = React.useRef(null) as any;
  const [loader, setLoader] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingListData, setLoadingListData] = useState(true);
  const [datatableListData, setDatatableListData] = useState([]);
  const [formData, setFormData] = useState({});
  const [masterFormModal, setMasterFormModal] = useState(false);
  const [deleteWhere, setDeleteWhere] = useState({
    id: "",
    company_profile_id: "",
  });
  const [recordName, setRecordName] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  
  useEffect(()=>{
    setLoadingListData(true);
    setDatatableListData([]);
  },[localStorage.getItem("I18N_LANGUAGE")])
  
  const create = async (values: formTypes_CompanyProfileType) => {
    try {
      toastId.current = toast(`${t("Creating")} ${masterName}...`, {
        autoClose: false,
        isLoading: true,
      });

      const res = (await companyProfileTypeService.create(values)) as any;
      if (res.data.status === "success") {
        toast.update(toastId.current, {
          type: toast.TYPE.SUCCESS,
          render: res.data.message,
          autoClose: 5000,
          isLoading: false,
          delay: 500,
        });
        setLoading(false);
        setMasterFormModal(false);
        setLoadingListData(true);
      } else {
        toast.update(toastId.current, {
          type: toast.TYPE.ERROR,
          render: res.data.message,
          autoClose: 5000,
          isLoading: false,
          delay: 500,
        });

        if (res.data.data) {
          Object.keys(res.data.data).map((key) => {
            toast(res.data.data[key][0], {
              type: toast.TYPE.ERROR,
              autoClose: 5000,
              delay: 500,
            });
          });
        }
        setLoading(false);
      }
    } catch (err: any) {
      toast.update(toastId.current, {
        type: toast.TYPE.ERROR,
        render: err?.message,
        autoClose: 5000,
        isLoading: false,
        delay: 500,
      });
      setLoading(false);
    }
  };

  const update = async (values: formTypes_CompanyProfileType) => {
    try {
      toastId.current = toast(`${t("Updating")} ${masterName}...`, {
        autoClose: false,
        isLoading: true,
      });

      const res = (await companyProfileTypeService.update(values)) as any;
      if (res.data.status === "success") {
        toast.update(toastId.current, {
          type: toast.TYPE.SUCCESS,
          render: res.data.message,
          autoClose: 5000,
          isLoading: false,
          delay: 500,
        });
        setLoading(false);
        setMasterFormModal(false);
        setLoadingListData(true);
      } else {
        toast.update(toastId.current, {
          type: toast.TYPE.ERROR,
          render: res.data.message,
          autoClose: 5000,
          isLoading: false,
          delay: 500,
        });

        if (res.data.data) {
          Object.keys(res.data.data).map((key) => {
            toast(res.data.data[key][0], {
              type: toast.TYPE.ERROR,
              autoClose: 5000,
              delay: 500,
            });
          });
        }
        setLoading(false);
      }
    } catch (err: any) {
      toast.update(toastId.current, {
        type: toast.TYPE.ERROR,
        render: err?.message,
        autoClose: 5000,
        isLoading: false,
        delay: 500,
      });
      setLoading(false);
    }
  };

  const deleteRecord = async (data: any) => {
    try {
      toastId.current = toast(`${t("Deleting")} ${masterName}...`, {
        autoClose: false,
        isLoading: true,
      });

      const res = (await companyProfileTypeService.delete(data)) as any;
      if (res.data.status === "success") {
        toast.update(toastId.current, {
          type: toast.TYPE.SUCCESS,
          render: res.data.message,
          autoClose: 5000,
          isLoading: false,
          delay: 500,
        });
        setLoading(false);
        setDeleteModal(false);
        setLoadingListData(true);
      } else {
        toast.update(toastId.current, {
          type: toast.TYPE.ERROR,
          render: res.data.message,
          autoClose: 5000,
          isLoading: false,
          delay: 500,
        });
        setLoading(false);
      }
    } catch (err: any) {
      toast.update(toastId.current, {
        type: toast.TYPE.ERROR,
        render: err?.message,
        autoClose: 5000,
        isLoading: false,
        delay: 500,
      });
      setLoading(false);
    }
  };

  const onClickCreate = () => {
    setFormData("");
    setMasterFormModal(true);
  };

  const onClickEdit = (row: any) => {
    setFormData(row);
    setMasterFormModal(true);
  };

  const onClickDelete = (row: any) => {
    const data = {
      ...deleteWhere,
      id: row.id,
      company_profile_id: row.company_profile_id,
    };
    setDeleteWhere(data);
    setRecordName(row.company_profile_value);
    setDeleteModal(true);
  };

  const handleSubmit = (values: any) => {
    if (values.id && values.company_profile_id) {
      update(values);
    } else {
      create(values);
    }
  };

  const handleDelete = () => {
    deleteRecord(deleteWhere);
  };

  function renderRowHTML(rowContent: any, row: any) {
    return <span dangerouslySetInnerHTML={{ __html: rowContent }} />;
  }
  const columns = [
    {
      dataField: "DT_RowIndex",
      text: t("Sr. No."),
      sort: false,
      search: false,
      classes: "fix-col-left",
      headerClasses: "fix-col-left",
      headerStyle: { width: "65px" },
      style: { width: "65px" },
    },
    {
      dataField: "company_profile_value",
      text: t("Company profile"),
      sort: true,
      search: true,
    },
    {
      dataField: "company_profile_value_french",
      text: "Profil de l'entreprise",
      sort: true,
      search: true,
    },
    {
      dataField: "company_profile_value_dutch",
      text: "Vennootschapsprofiel",
      sort: true,
      search: true,
    },
    {
      dataField: "action",
      text: "Action",
      sort: false,
      search: false,
      formatter: (rowContent: any, row: any): any => {
        return (
          <div className="d-flex gap-2 text-end">
            <Link
              className="btn btn-pill btn-outline-primary btn-sm"
              to="#"
              onClick={() => onClickEdit(row)}
            >
              <span className="align-middle material-symbols-outlined fw-light fs-5 me-1">
                edit
              </span>
              {t("Edit")}
            </Link>
            {row.no_delete === 0 ? (
              <Link
                className="btn btn-pill btn-outline-danger btn-sm"
                to="#"
                onClick={() => onClickDelete(row)}
              >
                <span className="align-middle material-symbols-outlined fw-light fs-5 me-1">
                  delete
                </span>
                {t("Delete")}
              </Link>
            ) : null}
          </div>
        );
      },
    },
  ];

  const [datatableOptions, setDatatableOptions] = useState({
    draw: 1,
    page: 1,
    recordsTotal: 0,
    recordsFiltered: 0,
    sizePerPage: 20,
    searchText: "",
    sortField: "id",
    sortOrder: "desc",
  });

  const onTableChange = (type: any, newState: any) => {
    let draw = datatableOptions.draw + 1;
    let page = 1;
    if (type == "search") {
      page = 1;
    } else {
      page = newState.page;
    }
    const updatedDatatableOptions = {
      ...datatableOptions,
      draw: draw,
      page: page,
      sizePerPage: newState.sizePerPage,
      searchText: newState.searchText,
      sortField: newState.sortField,
      sortOrder: newState.sortOrder,
    };
    setDatatableOptions(updatedDatatableOptions);
    setDatatableListData([]);
    setLoadingListData(true);
  };

  const clearFilter = () => {
    const updatedDatatableOptions = {
      ...datatableOptions,
      draw: 1,
      page: 1,
      sizePerPage: 20,
      searchText: "",
      sortField: "id",
      sortOrder: "desc",
    };
    setDatatableOptions(updatedDatatableOptions);
    setLoadingListData(true);
  };

  const loadingDatatable = async () => {
    try {
      const res = (await companyProfileTypeService.getAll(
        getDataTableQuery(datatableOptions, columns)
      )) as any;

      if (res.data.status === "success") {
        setDatatableListData(res.data.data);

        const updatedDatatableOptions = {
          ...datatableOptions,
          recordsTotal: res.data.recordsTotal,
          recordsFiltered: res.data.recordsFiltered,
        };
        setDatatableOptions(updatedDatatableOptions);
        setLoadingListData(false);
      } else {
        setDatatableListData([]);
        setLoadingListData(false);
      }
    } catch (err) {
      setDatatableListData([]);
      setLoadingListData(false);
    }
  };

  useEffect(() => {
    if (loadingListData === true) {
      loadingDatatable();
    }
  }, [loadingListData]);

  return (
    <React.Fragment>
      {deleteWhere && (
        <DeleteModal
          recordName={recordName}
          modalTitle={masterName}
          show={deleteModal}
          onDeleteClick={handleDelete}
          onCloseClick={() => setDeleteModal(false)}
          loading={loading}
        />
      )}

      {masterFormModal && (
        <FormModal
          show={masterFormModal}
          loading={loading}
          formData={formData}
          onSubmitClick={handleSubmit}
          onCloseClick={() => setMasterFormModal(false)}
        />
      )}

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            breadcrumbTitle={masterName}
            breadcrumbItems={breadcrumbItems}
            endAdornment={
              <Link
                to="#"
                className="btn btn-primary btn-sm waves-effect waves-light btn-label"
                onClick={() => onClickCreate()}
              >
                <span className="align-middle material-symbols-outlined fw-light fs-4 label-icon">
                  add
                </span>
                {t("Create")} {masterName}
              </Link>
            }
          />

          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <DataTable
                    columns={columns}
                    products={datatableListData}
                    datatableOptions={datatableOptions}
                    filters={[]}
                    onTableChange={onTableChange}
                    loadingListData={loadingListData}
                    clearFilter={clearFilter}
                    settingTableName="company_profile_master_table"
                    slug="masters"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MasterForm;
